// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  merchantPaymentFormSchema,
  MerchantPaymentValuesType,
  merchantPaymentInitialValues,
} from "./_formTypes";
import {
  useGetPayment3DTrxSettingsList,
  useGetAcquirerBankList,
  GetMerchantPaymentRequest,
  useGetMerchantPayment,
  useCancelPaymentAndTransaction,
  CancelPaymentAndTransactionRequest,
  useRefundPaymentAndTransaction,
  RefundPaymentAndTransactionRequest,
  useGetTrxStatusSettingsList,
  BasePagingResponse,
  PagingResponse,
  useAuthorization,
  useGetAllMerchantList,
  useSendMoney,
  useGetMerchantsWithParentMerchant,
} from "../../../hooks";
import {
  GridColDef,
  GridActionsCellItem,
  GridValueFormatterParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  Link,
  Box,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Checkbox
} from "@mui/material";
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DateTimePickerControl,
  Table,
  DeleteConfirmModal,
  InputControl,
  NumericFormatInputControl,
  MechantPaymentModal,
  DatePickerControl,
  createBooleanOperator,
  TextAreaInputControl
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export const MerchantEndOfDayComponent = () => {
  const theme = useTheme();
  const user = useLocation().state as unknown as IUser | undefined;
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<MerchantPaymentValuesType>({
      resolver: zodResolver(merchantPaymentFormSchema),
      defaultValues: merchantPaymentInitialValues,
    });
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: -1,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const { mutate: GetMerchantPayment, isLoading: isGetMerchantPaymentLoading } =
    useGetMerchantPayment();
  const { mutate: sendMoney, isLoading: isGetSendMoneyLoading } =
    useSendMoney();
  const setSnackbar = useSetSnackBar();
  // const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
  const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant();
  const [userInfo] = useUserInfo();
  useEffect(() => {
    const currentDate = dayjs();
    setValue("startPaymentMerchantDate", currentDate);
    setValue("endPaymentMerchantDate", currentDate);
  }, [setValue]);
  const [openDialog, setOpenDialog] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(
    user
      ? Number(userInfo.merchantId) !== 0
        ? { label: userInfo.merchantName, value: Number(userInfo.merchantId) }
        : null
      : null
  );

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmPay = () => {
    handleBulkPay()
    setOpenDialog(false);
  };

  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);


  const [formValues, setFormValues] =
    useState<MerchantPaymentValuesType | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = (data: MerchantPaymentValuesType) => {
    setFilterAccordionExpand(false);
    setTableData(undefined);
    setShowTable(true)
    const actualMerchantId = data.merchantId || +userInfo?.merchantId;

    const filterMerchantId = Array.isArray(data.filterMerchantId) ? data.filterMerchantId : [data.filterMerchantId ?? 0];

    const req: GetMerchantPaymentRequest = {
      page: paginationModel.page,
      size: paginationModel.pageSize,
      orderByDesc: true,
      orderBy: "CreateDate",
      status: data.status,
      merchantId: filterMerchantId,

      startPaymentMerchantDate: data?.startPaymentMerchantDate
        ? dayjs(data.startPaymentMerchantDate).format("YYYY-MM-DD")
        : "",
      endPaymentMerchantDate: data?.endPaymentMerchantDate ? dayjs(data.endPaymentMerchantDate).format("YYYY-MM-DD") : "",
      paymentFlag: data.paymentFlag,
    };

    if (data?.startDate) {
      req.startDate = dayjs(
        data.startDate
      ).format("YYYY-MM-DD");
    }

    if (data?.endDate) {
      req.endDate = dayjs(data.endDate).format(
        "YYYY-MM-DD"
      );
    }

    setFormValues(req);
    setIsSubmitted(true);

    // GetMerchantPayment(req, {
    //   onSuccess: (data) => {
    //     if (data.isSuccess) {
    //       setTableData(data.data);
    //       setFormValues(req);
    //       setIsSubmitted(true);
    //       setSnackbar({
    //         severity: "success",
    //         isOpen: true,
    //         description: data.message,
    //       });
    //     } else {
    //       setSnackbar({
    //         severity: "error",
    //         description: data.message,
    //         isOpen: true,
    //       });
    //     }
    //   },
    //   onError: () => {
    //     setSnackbar({
    //       severity: "error",
    //       description: "İşlem sırasında bir hata oluştu",
    //       isOpen: true,
    //     });
    //   },
    // });
  };
  useEffect(() => {
    if (!isSubmitted || formValues == null) {
      return;
    }
    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    GetMerchantPayment(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [formValues, isSubmitted, queryOptions, shouldRefresh]);

  const PayButton = ({ rowData, sendMoney, control, getValues, currency }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [localPaymentAmount, setLocalPaymentAmount] = useState(null);
    const [isValid, setIsValid] = useState(true);

    const [paymentDescription, setPaymentDescription] = useState(null);

    // TRY kontrolü
    const displayCurrency = currency === 'TRY' ? 'TL' : currency;
    const handleOpen = () => {
      if (localPaymentAmount === null) {
        setLocalPaymentAmount(rowData.paymentAmount);
      }
      setDialogOpen(true);
    };

    const handleClose = () => {
      setDialogOpen(false);
      setLocalPaymentAmount(null);
    };

    const handlePay = () => {
      const paymentAmount = getValues("paymentAmount");

      if (!localPaymentAmount || localPaymentAmount <= 0) {
        setIsValid(false);
        setSnackbar({
          severity: "error",
          description: "Ödeme miktarı 0 veya boş olamaz",
          isOpen: true,
        });
        return;
      }
      const requestData: IVakifBankSendMoneyRequest = {
        merchantId: rowData.merchantId,
        merchantName: rowData.accountOwner,
        iban: rowData.iban,
        bankCode: rowData.bankCode,
        paymentAmount: +localPaymentAmount,
        currencyCode: +rowData.currency,
        identityNumber: rowData.taxNumber,
        endOfDayDate: rowData.paymentMerchantDate,
        transactionId: uuidv4(),
        paymentDescription: document.getElementById('paymentDescription')?.value ?? null
      };

      sendMoney([requestData], {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
            setShouldRefresh((prev) => !prev);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      });

      handleClose();
    };

    return (
      <>
        <Button
          text="Öde"
          variant="text"
          color="info"
          sx={{ flex: 1, height: 20, py: 5 }}
          onClick={handleOpen}
        >
          Öde
        </Button>

        <Dialog open={dialogOpen} onClose={handleClose}>
          <DialogTitle>Ödeme Miktarı</DialogTitle>
          <DialogContent>
            <FormControl sx={{ width: 290, mt: 3 }}>
              <NumericFormatInputControl
                sx={{ flex: 1 }}
                label="Üye İşyeri Hak Ediş Tutarı"
                control={control}
                id="paymentAmount"
                adornmentText={displayCurrency}
                thousandSeparator="."
                value={localPaymentAmount}
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                onValueChange={(values) => {
                  setLocalPaymentAmount(values.floatValue);
                }}
              />
              <TextAreaInputControl
                sx={{ marginTop: 2 }}
                placeholder="Açıklama"
                uniqueId="paymentDescription"
              />
            </FormControl>
            {/* <FormControl sx={{ width: 290, mt: 3 }}>
              
            </FormControl> */}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handlePay}
              color="primary"
              text=" Ödemeyi Tamamla"
              variant="contained"
            >
              Ödemeyi Tamamla
            </Button>
            <Button onClick={handleClose} color="primary" text="Iptal">
              İptal
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };



  const handleBulkPay = () => {
    const bulkRequestData = selectedRows.map((row) => {
      return {
        merchantId: row.merchantId,
        merchantName: row.accountOwner,
        iban: row.iban,
        bankCode: row.bankCode,
        paymentAmount: row.paymentAmount,
        currencyCode: +row.currency,
        identityNumber: row.taxNumber,
        endOfDayDate: row.paymentMerchantDate,
        transactionId: uuidv4(),
        paymentDescription: document.getElementById('paymentDescriptionBulk')?.value ?? null
      };
    });

    if (bulkRequestData.length === 0) {
      console.error("No valid rows to send.");
      return;
    }

    // Toplu API isteği yap
    sendMoney(bulkRequestData, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
          setShouldRefresh((prev) => !prev);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  function RenderActionButton(transaction: any) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal}
          text="Detay"
          sx={{ flex: 1, height: 20, py: 4 }}
        ></Button>
        <MechantPaymentModal
          transaction={transaction}
          isOpen={isModalOpen}
          handleClose={handleCloseModal}
        />
      </>
    );
  }

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );
  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDesc = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ? (
            <GridActionsCellItem
              // label="Sil"
              // onClick={deleteRow(params.row)}
              icon={RenderActionButton(params.row)}
            />
          ) : (
            <></>
          ),
        ],
      },

      {
        field: "payButton",
        headerName: "Öde",
        width: 150,
        renderCell: (params) => {
          return <PayButton rowData={params.row} sendMoney={sendMoney} control={control} getValues={getValues} currency={params.row.currencyDesc} />;
        },
      },
      {
        field: "merchantId",
        headerName: "Üye İşyeri Numarası",
        width: 180,
        resizable: true,
      },
      {
        field: "merchantName",
        headerName: "Üye İşyeri Adı",
        resizable: true,
        width: 300,
      },
      {
        field: "paymentAmountFlag",
        headerName: "Ödeme Yapıldı mı ?",
        width: 200,
        resizable: true,
        renderCell: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
      },
      {
        field: "paidDate",
        headerName: "Ödeme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      {
        field: "paidAmount",
        headerName: "Ödenen Tutar",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "paymentMerchantDate",
        headerName: "Üye İşyeri Ödeme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      {
        field: "merchantCommissionAmount",
        headerName: "Üye İşyeri Komisyon Tutarı",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },

      {
        field: "paymentAmount",
        headerName: "Üye İşyeri FTP Hak Ediş Tutarı",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "paymentAmountBalance",
        headerName: "Üye İşyeri Cari Hak Ediş Tutarı",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "currencyDesc", headerName: "Para Birimi", width: 300,
        filterOperators: [createBooleanOperator(currencyDesc)],
      },
      { field: "bankCode", headerName: "Banka Kodu ", width: 300 },
      { field: "accountOwner", headerName: "Hesap Sahibi", width: 300 },
      { field: "iban", headerName: "İban", width: 300 },
    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const actualMerchantId = getValues("merchantId") || data.merchantId || +userInfo?.merchantId;
    const requestPayload = {
      merchantId: actualMerchantId,
      startPaymentMerchantDate: getValues("startPaymentMerchantDate")
        ? dayjs(getValues("startPaymentMerchantDate")).format("YYYY-MM-DD")
        : "",
      endPaymentMerchantDate: getValues("endPaymentMerchantDate")
        ? dayjs(getValues("endPaymentMerchantDate")).format("YYYY-MM-DD")
        : "",
      status: getValues("status"),
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      paymentFlag: getValues("paymentFlag"),
      orderByDesc: true,
    };
    if (getValues("startDate")) {
      requestPayload.startDate = dayjs(
        getValues("startDate")
      ).format("YYYY-MM-DD");
    }

    // Conditionally add endPaymentMerchantDate if it exists
    if (getValues("endDate")) {
      requestPayload.endDate = dayjs(
        getValues("endDate")
      ).format("YYYY-MM-DD");
    }

    GetMerchantPayment(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const onSave = () => {

    const filterMerchantId = Array.isArray(getValues('filterMerchantId')) ? getValues('filterMerchantId') : getValues('filterMerchantId') ? [getValues('filterMerchantId') ?? 0] : [0];

    const requestPayload = {
      page: 0,
      size: -1,
      orderBy: "CreateDate",
      paymentFlag: getValues("paymentFlag"),
      merchantId: filterMerchantId,
      orderByDesc: true,
      startPaymentMerchantDate: dayjs(getValues("startPaymentMerchantDate")).format("YYYY-MM-DD"),
      endPaymentMerchantDate: dayjs(getValues("endPaymentMerchantDate")).format("YYYY-MM-DD"),

      ...getQueryParams(queryOptions),
    };

    if (getValues("startDate")) {
      requestPayload.startDate = dayjs(
        getValues("startDate")
      ).format("YYYY-MM-DD");
    }

    if (getValues("endDate")) {
      requestPayload.endDate = dayjs(
        getValues("endDate")
      ).format("YYYY-MM-DD");
    }
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetMerchantPayment(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          function fieldValue(data) {
            return data.map((item) => {
              return {
                "Üye İşyeri Numarası": item?.merchantId,
                "Üye İşyeri Adı": item?.merchantName,
                "Ödeme Yapıldı Mı?": item?.paymentAmountFlag ? "Evet" : "Hayır",
                "Ödeme Tarihi": item?.paidDate,
                "Ödenen Tutar": item?.paidAmount,
                "Üye İşyeri Ödeme Tarihi": item?.paymentMerchantDate,
                "Üye İşyeri Komisyon Tutarı": item?.merchantCommissionAmount,
                " Üye İşyeri FTP Hak Ediş Tutarı": item?.paymentAmount,
                " Üye İşyeri Cari Hak Ediş Tutarı": item?.paymentAmount,
                "Para Birimi": item?.currencyDesc,
                "Banka Kodu": item?.bankCode,
                "Hesap Sahibi": item?.accountOwner,
                "İban": item?.iban,

                // "Gün Sonu Tarihi": item?.endOfDayDate,
              };
            });
          }
          const refactoredData = fieldValue(data?.data?.result);
          downloadExcel(refactoredData || [], "İşyeri Hak Ediş Raporları");
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  const decimalFields = [
    'installmentCount', 'cardType',
    'paidAmount',
    'merchantCommissionAmount',
    'paymentAmount',
  ]

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      // Eğer gelen değer string "false" ise onu boolean false'a çevir
      if (value === "false") {
        queryParams[key] = false;
      } else if (key === "merchantId") {
        queryParams[key] = Array.isArray(value) ? value.map(Number) : [Number(value)];
      } else if (value !== null && value !== undefined && value.toString().length > 0) {
        if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
          queryParams[key] = parseFloat(value).toFixed(2);
        } else {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };
  const keyRules = {
    'installmentCount': 1,
    'cardType': 1,
    'paidAmount': 1,
    'merchantCommissionAmount': 1,
    'paymentAmount': 1
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      const minLength = keyRules[key] || 3;
      return value?.toString().length >= minLength;
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
    }


    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasLoading = isGetMerchantPaymentLoading || isGetSendMoneyLoading;

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

  return (
    <>
      {hasLoading && <Loading />}
      <div>
        {/* Dialog bileşeni */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperProps={{
            style: {
              width: '300px',
              padding: 3
            },
          }}
        >
          <DialogTitle className="customDialogTitle">Ödeme Onayı</DialogTitle>
          <DialogContent >
            <TextAreaInputControl
              sx={{ marginTop: 2, width: '100%' }}
              placeholder="Açıklama"
              uniqueId="paymentDescriptionBulk"
            />
            <DialogContentText className="customDialogContent">
              Ödemeyi onaylıyor musunuz?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmPay} color="primary" variant="contained" text="Evet">
              Evet
            </Button>
            <Button onClick={handleCloseDialog} color="primary" variant="outlined" text="Hayır">
              Hayır
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>

          <BaseFilterTableWithAccordion summary="İşyeri Hak Ediş Raporları" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={5}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="startPaymentMerchantDate"
                    control={control}
                    label="Üye İşyeri Ödeme Başlangıç Tarihi"
                    defaultValue={dayjs().subtract(1, "day")}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="endPaymentMerchantDate"
                    control={control}
                    label="Üye İşyeri Ödeme Bitiş Tarihi"

                    defaultValue={dayjs()}
                  />
                </FormControl>
              </Stack>

              <Stack
                spacing={5}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="startDate"
                    label="Gün Sonu Başlangıç Tarihi"
                    control={control}

                  />
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="endDate"
                    control={control}
                    label="Gün Sonu Bitiş Tarihi"
                  />
                </FormControl>
              </Stack>

              <Stack
                spacing={1}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="filterMerchantId"
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          id="merchant-multi-checkbox"
                          options={merchantList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => {
                            // Seçilen tüm değerlerin dizisini güncelliyoruz
                            field.onChange(newValue.map((item) => item.value));
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.value}>
                              <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                          )}
                        />
                      )}
                    />
                  )}
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  <Controller
                    name="paymentFlag"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControl component="fieldset" fullWidth sx={{ ml: 2 }}>
                        <FormLabel component="legend">
                          Ödeme Yapıldı mı?
                        </FormLabel>
                        <RadioGroup
                          aria-label="paymentFlag"
                          name="paymentFlag"
                          value={value}
                          onChange={(e) => onChange(e.target.value === "true")}
                          row
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Evet"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Hayır"
                          />
                        </RadioGroup>
                      </FormControl>
                    )}
                  />
                </FormControl>
              </Stack>

              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? 800 : "auto"}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />

          <Stack flex={1} mt={2}>

            <>
              {showTable && (
                <Table
                  columnVisibilityConfigKey="merchantEndOfDayColumnVisibilityKey"
                  className="myTable"
                  hasActiveFilters={hasActiveFilters}
                  handleFilterChange={handleFilterChange}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems}
                  getRowId={(row) => row.uniqueId}
                  disableRowSelectionOnClick
                  handleBulkPay={handleBulkPay}
                  sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
                  // isRowSelectable={() => false}
                  checkboxSelection
                  onRowSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const newSelectedRows = tableData?.result.filter((row) => selectedIDs.has(row.uniqueId));
                    setSelectedRows(newSelectedRows);
                  }}
                  {...tableData?.result}
                  openDialog={setOpenDialog}
                  selectedRows={selectedRows}
                  showBulkPayButton={true}
                  rows={tableData?.result || []}
                  autoHeight={!isDesktop}
                  customLabelDisplayedRows={true}
                  columns={columns}
                  exportFileName="İşyeri Hak Ediş Raporları"
                  onSave={() => onSave()}
                />
              )}

            </>

          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
